module.exports = __webpack_public_path__ + "static/media/shortl-image.c056b72b.png";